// application.js
import { Application } from "@hotwired/stimulus";
import { Dropdown, Modal, Popover } from "tailwindcss-stimulus-components";
import { Autocomplete } from "stimulus-autocomplete";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

application.register("dropdown", Dropdown);
application.register("modal", Modal);
application.register("popover", Popover);
application.register("autocomplete", Autocomplete);


export { application };
